<app-text
  id="shared-radio-label-text"
  [textStyleType]="radioLabelFontType"
  class="radio-label"
  >{{ radioLabel }}
  <span id="shared-label-select-required" *ngIf="isRequired" class="red-color">*</span>
</app-text>
<mat-radio-group class="radio-group">
  <app-radio-button
    id="shared-radio-button"
    [title]="item.title"
    [value]="'item.id'"
    (radiobuttonChange)="onRadioButtonSelected(item)"
    *ngFor="let item of data"
    [disableTooltip]="!item.showTooltip"
    [tooltipTextKey]="tooltipTextKey"
    [checked]="getCheckedData(item)"
    [fontType]="'body1'"
    [disabled]="isOptionDisabled(item)"
    [control]="dataControl"
  ></app-radio-button>
</mat-radio-group>
